var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActionCloseDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.312789 3.29289C-0.077735 3.68342 -0.0777356 4.31658 0.312789 4.70711L2.59145 6.98576L0.292893 9.28432C-0.097631 9.67484 -0.097631 10.308 0.292893 10.6985C0.683418 11.0891 1.31658 11.0891 1.70711 10.6985L4.71341 7.69223C5.10393 7.3017 5.10393 6.66854 4.71341 6.27802C4.70322 6.26782 4.69286 6.2579 4.68235 6.24824L1.727 3.29289C1.33648 2.90237 0.703314 2.90237 0.312789 3.29289Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6872 3.29289C14.0777 3.68342 14.0777 4.31658 13.6872 4.70711L11.4086 6.98576L13.7071 9.28432C14.0976 9.67484 14.0976 10.308 13.7071 10.6985C13.3166 11.0891 12.6834 11.0891 12.2929 10.6985L9.28659 7.69223C8.89607 7.3017 8.89607 6.66854 9.28659 6.27802C9.29678 6.26782 9.30714 6.2579 9.31765 6.24824L12.273 3.29289C12.6635 2.90237 13.2967 2.90237 13.6872 3.29289Z",
    fill: "white",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionCloseDark);
export default __webpack_public_path__ + "static/media/action-close-dark.5f9fcd43633cbcc7d9f01240978b5b1e.svg";
export { ForwardRef as ReactComponent };